/**
 * Starter widget layout shown when a user has no saved widgets yet.
 * Kept in sync with server/src/constants/defaultDashboardLayout.js
 */

export const DEFAULT_GRID_CONFIG = {
  columns: 12,
  rowHeight: 100,
  margin: 10,
};

export const HOME_DEFAULT_LAYOUT = [
  {
    type: "playerChart",
    title: "Aaron vs Bonds — Home Runs",
    config: {
      type: "comparison",
      players: [
        { id: "aaronha01", name: "Hank Aaron" },
        { id: "bondsba01", name: "Barry Bonds" },
      ],
      selectedStat: "homeruns",
      statCategory: "hitting",
      normalizeByCareer: true,
    },
    position: { x: 0, y: 0 },
    size: { width: 6, height: 4 },
  },
  {
    type: "table",
    title: "All-Time HR Leaders",
    dataSource: "leaderboard",
    timeRange: "all",
    refreshInterval: 1800,
    settings: {
      columns: ["rank", "name", "value"],
      showHeader: true,
      maxRows: 10,
    },
    position: { x: 6, y: 0 },
    size: { width: 6, height: 5 },
  },
  {
    type: "mlbScores",
    title: "Today's Scores",
    dataSource: "mlb-scores",
    refreshInterval: 300000,
    settings: {
      showLiveGames: true,
      showCompletedGames: true,
      showScheduledGames: true,
      maxGames: 20,
    },
    position: { x: 0, y: 4 },
    size: { width: 6, height: 6 },
  },
  {
    type: "playerChart",
    title: "Aaron Judge — Career HRs",
    config: {
      type: "single",
      players: [{ id: "judgeaa01", name: "Aaron Judge" }],
      selectedStat: "homeruns",
      statCategory: "hitting",
      normalizeByCareer: true,
    },
    position: { x: 6, y: 5 },
    size: { width: 6, height: 4 },
  },
];

export function getDefaultDashboardLayout(dashboardType = "home") {
  switch (dashboardType) {
    case "home":
      return {
        layout: HOME_DEFAULT_LAYOUT,
        gridConfig: DEFAULT_GRID_CONFIG,
      };
    default:
      return {
        layout: [],
        gridConfig: DEFAULT_GRID_CONFIG,
      };
  }
}
